import React, { useState, useEffect } from 'react';
import api from '../utils/api';

export default function ConnectionsView({ showToast, setViewedUserId, setCurrentView }) {
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConnections = async () => {
      try {
        setLoading(true);
        const res = await api.get('/connections');
        setConnections(res.data.connections || []);
      } catch (err) {
        console.error('Error fetching connections:', err);
        showToast('Unable to load connections.');
      } finally {
        setLoading(false);
      }
    };

    fetchConnections();
  }, []);

  const handleProfileClick = (userId) => {
    setViewedUserId(userId);
    setCurrentView('profile');
  };

  if (loading) {
    return <div style={{ color: 'var(--text2)', padding: '20px' }}>Loading connections...</div>;
  }

  return (
    <div className="view active" id="view-favourites">
      <div className="fav-title">Connections</div>
      <div className="fav-partext">Mutual connections on Buniverse.
    </div>
  
  <div className="fav-panel">

      {connections.length === 0 ? (
        <div style={{ color: 'var(--text3)', fontSize: '14px', fontStyle: 'italic', marginTop: '20px' }}>
          No mutual connections yet. Connect with creatives who follow you back!
        </div>
      ) : (
        <div id="connections-list" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {connections.map((person) => (
            <div 
              key={person.user_id} 
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 16px',
                backgroundColor: 'var(--bg-card, rgba(255,255,255,0.03))',
                borderRadius: '10px',
                border: '1px solid var(--border-color, rgba(255,255,255,0.08))'
              }}
            >
              <div 
                style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}
                onClick={() => handleProfileClick(person.user_id)}
              >
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--teal, #00d2c1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: '600',
                  color: '#fff',
                  overflow: 'hidden'
                }}>
                  {person.avatar_url ? (
                    <img src={person.avatar_url} alt={person.display_name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    person.display_name?.charAt(0) || 'U'
                  )}
                </div>
                <div>
                  <div style={{ fontWeight: '600', color: 'var(--text)', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    {person.display_name}
                    {person.is_verified && <span style={{ color: 'var(--teal)', fontSize: '12px' }}>✦</span>}
                  </div>
                  <div style={{ fontSize: '12px', color: 'var(--text3)' }}>@{person.handle}</div>
                </div>
              </div>

              <button 
                class="connections-view" 
                onClick={() => handleProfileClick(person.user_id)}
                style={{}}
              >
                View Profile
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
    </div>
  );
}